'use strict';

/* Filters */

angular.module('FlexyBeautyApp.filters', []).
    filter('currencyFormatFilter', ['$filter','LanguageManager','CurrencyManager','NumberSeparatorType', function($filter, LanguageManager, CurrencyManager, NumberSeparatorType) {
        return function(text) {
            let formattedNumber = text;

            if(formattedNumber !== null) {
                if (LanguageManager.getLanguageCode() && LanguageManager.getCountryCode() && CurrencyManager.getCurrencyCodeIso()) {
                    if(typeof(formattedNumber) === "string"){
                        formattedNumber = CurrencyManager.getPriceFromPriceInput(formattedNumber);
                        formattedNumber = parseFloat(formattedNumber);
                    }
                    if(!isNaN(formattedNumber)) {
                        let intlFormater = CurrencyManager.getIntlFormatter();
                        if (intlFormater) {
                            formattedNumber = intlFormater.format(formattedNumber);
                        }
                        else {
                            formattedNumber = formattedNumber.toLocaleString(LanguageManager.getLocale(), {
                                style: 'currency',
                                currency: CurrencyManager.getCurrencyCodeIso(),
                            });
                        }
                    }
                    else{
                        formattedNumber = text;
                    }
                }
            }
            return formattedNumber;
        }
    }])
    .filter('interpolate', ['version', function(version) {
        return function(text) {
          return String(text).replace(/\%VERSION\%/mg, version);
        }
      }])
    .filter('trustHtml', [
        '$sce',
        function($sce) {
            return function(value) {
                return $sce.trustAs('html', value);
            }
        }
    ])
    .filter('matchSkill', function() {
        return function( services,humainResource) {
            var filtered = [];
            angular.forEach(services, function(service) {
                if(humainResource.servicesId.indexOf(service.id)>=0) {
                    filtered.push(service);
                }
            });
            return filtered;
        };
    }).filter('canPerformBookingService', function() {
        return function(resourcesView ,bookingServiceView) {
            var filtered = [];
            if (bookingServiceView.bookingView  && bookingServiceView.bookingView.plgDayView)
                angular.forEach(resourcesView, function(resourceView) {
                    //TODO check open period instead open day
                    var dayHrView =  bookingServiceView.bookingView.plgDayView.getPlgDayHrView(resourceView);
                    if (resourceView.knowsServiceView(bookingServiceView.serviceView) &&
                        dayHrView && dayHrView.isWorkingDay)
                        filtered.push(resourceView);
                });
            return filtered;
        };
    })
    .filter('canPerformBookingServiceOnPr', function() {
        return function(physicalResourcesUnitView ,bookingServiceView) {
            var filtered = [];
            angular.forEach(physicalResourcesUnitView, function(physicalResourceUnitView) {
                if (bookingServiceView.bookingView  && bookingServiceView.bookingView.plgDayView)
                {
                    //TODO check open period instead open day
                    var dayPrView =  bookingServiceView.bookingView.plgDayView.getPlgDayPrView(physicalResourceUnitView.prView,physicalResourceUnitView.prUnitId);
                    if (physicalResourceUnitView.prView.knowsServiceView(bookingServiceView.serviceView) &&
                        dayPrView && dayPrView.isWorkingDay)
                        filtered.push(physicalResourceUnitView);
                }
            });
            return filtered;
        };
    }).filter('labelLowerCaseFilter', function() {
        return function(objectsToFilter ,filter) {
            var filtered = [];
            if (!filter || filter.length<2)
                return objectsToFilter;
            var filterLowCase = filter.toLowerCase();
            angular.forEach(objectsToFilter, function(objectToFilter) {
                if (objectToFilter.labelLowerCase && objectToFilter.labelLowerCase.indexOf(filterLowCase)!=-1 )
                    filtered.push(objectToFilter);
            });
            return filtered;
        };
    }).filter('filterDays', function() {
        return function(days,daysToDisplay ) {
            var filtered = [];
            for (var z =0; z<days.length && z<daysToDisplay;z++ )
                    filtered.push(days[z]);
            return filtered;
        };
    })
    .filter('numberFixedLen', function () {
        return function (n, len) {
            var num = parseInt(n, 10);
            len = parseInt(len, 10);
            if (isNaN(num) || isNaN(len)) {
                return n;
            }
            num = ''+num;
            while (num.length < len) {
                num = '0'+num;
            }
            return num;
        };
    })
    .filter('numberDot', [ "$filter",function ($filter) {
        return function (input, fractionSize) {
            if (isNaN(input)) {
                return input;
            } else {
                return ($filter('number')(input, fractionSize)).replace(",",".");
            };
        };
    }])
    .filter('smartNumber', [ "$filter",function ($filter) {
        return function (input, fractionSize) {
            if (isNaN(input)) {
                return input
            } else {
                if (input% 1 === 0)//not a float
                    return input;
                else
                    return ($filter('number')(input, fractionSize));
            };
        };
    }])
    .filter('searchCustomer', [function () {
        return function(customersView, inputSearch ) {
            let filtered = [];
            if (!inputSearch || inputSearch === "" || inputSearch.length < 2) {
                return [];
            }

            inputSearch = inputSearch.toLowerCase();

            for (let z = 0; z < customersView.length; z++) {
                let customerView = customersView[z];
                let lastName = customerView.lastName ? customerView.lastName.toLowerCase() : customerView.lastName;
                let firstName = customerView.firstName ? customerView.firstName.toLowerCase() : customerView.firstName;
                let label = customerView.label ? customerView.label.toLowerCase() : customerView.label;
                let customerPhone = customerView.customerPhone;
                let email = customerView.email;
                let customerNationalMobileNumber = customerView.customerNationalMobileNumber;
                let customerNationalLandlineNumber = customerView.customerNationalLandlineNumber;
                let customerInterNationalMobileNumber = customerView.customerInterNationalMobileNumber;
                let customerInterNationalLandlineNumber = customerView.customerInterNationalLandlineNumber;

                if ((lastName && lastName.indexOf(inputSearch) === 0) ||
                    (firstName && firstName.indexOf(inputSearch) === 0) ||
                    (customerPhone && customersView[z].customerPhone.indexOf(inputSearch) === 0) ||
                    (label && label.indexOf(inputSearch) === 0) ||
                    (email && customersView[z].email.indexOf(inputSearch) === 0) ||
                    (customerNationalMobileNumber && customerNationalMobileNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0) ||
                    (customerInterNationalMobileNumber && customerInterNationalMobileNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0) ||
                    (customerNationalLandlineNumber && customerNationalLandlineNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0) ||
                    (customerInterNationalLandlineNumber && customerInterNationalLandlineNumber.indexOf(inputSearch.replace(/\s/g, '')) === 0)) {
                    filtered.push(customerView);
                }
            }

            return filtered;
        };
    }])
    .filter('searchSupplier', [function () {
        return function(suppliersView,inputSearch ) {
            var filtered = [];
            if (!inputSearch||inputSearch==""||inputSearch.length<2)
                return suppliersView;
            for (var z =0; z<suppliersView.length;z++ )
                if ((suppliersView[z].label && suppliersView[z].label.indexOf(inputSearch)==0) )
                    filtered.push(suppliersView[z]);
            return filtered;
        };
    }]).filter('searchCompany', [function () {
        return function( companiesView,inputSearch ) {
            var filtered = [];
            if (!inputSearch||inputSearch==""||inputSearch.length<2)
                return  companiesView;
            for (var z =0; z< companiesView.length;z++ )
                if (( companiesView[z].name &&  companiesView[z].name.indexOf(inputSearch)==0) )
                    filtered.push( companiesView[z]);
            return filtered;
        };

    }]).filter('searchLinesInvoice', [function () {
        return function( linesInvoices,inputSearch ) {
            var filtered = [];
            if (!inputSearch||inputSearch==""||inputSearch.length<2)
                return  linesInvoices;
            for (var z =0; z< linesInvoices.length;z++ )
                if (( linesInvoices[z] &&  linesInvoices[z].indexOf(inputSearch)==0) )
                    filtered.push( linesInvoices[z]);
            return filtered;
        };

    }]).filter('reverse', function() {
        return function(items) {
            if (items)
                return items.slice().reverse();
        };
    }).filter('minutesToTimeString', function() {
        return function(minutesIn) {
            if (!minutesIn)
                return "";
            var hours = Math.floor(minutesIn / 60);
            var minutes = Math.floor(minutesIn % 60);
            var timeString = '';
            if(hours > 0)
            {
                timeString += hours +"h";
                if (minutes<10)
                    timeString +="0";
            }
            if(minutes >= 0)
            {
                timeString += minutes;
                if(minutes > 0 && hours==0)
                    timeString += String.fromCharCode(8239)+"min";
            }
            return timeString;
        }
    }).filter('shorterMinutesToTimeString', function() {
    return function(minutesIn) {
        if (!minutesIn)
            return "";
        var hours = Math.floor(minutesIn / 60);
        var minutes = Math.floor(minutesIn % 60);
        var timeString = '';
        if(hours > 0)
        {
            timeString += hours +"h";
            if (minutes > 0 && minutes < 10)
                timeString +="0";
        }
        if(minutes > 0)
        {
            timeString += minutes;
            if(minutes > 0 && hours==0)
                timeString += String.fromCharCode(8239)+"min";
        }
        return timeString;
    }
});





// WEBPACK FOOTER //
// ./js/filters.js